import humanize from 'humanize'
import { string, func, number, oneOfType } from 'prop-types'
import {
  Button,
  Conditional,
  Tooltip,
  renderIcon,
  kuiperClassNames,
} from '@opallabs/kuiper'
import './styles.scss'

const downloadButton = (eventHandler) => (
  <Button type="invisible" icon="download" onClick={eventHandler} />
)

const Attachment = ({
  description,
  fileName,
  fileSize,
  onDownload,
  onView,
  title,
}) => (
  /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
  <div className={kuiperClassNames('attachment')}>
    <Conditional condition={title}>
      <span>{title}</span>
    </Conditional>
    <Conditional condition={description}>
      <p className={kuiperClassNames('attachment-description')}>
        {description}
      </p>
    </Conditional>
    <div className={kuiperClassNames('attachment-file')}>
      <div className={kuiperClassNames('title')} onClick={onView}>
        {renderIcon('file', {
          ariaLabel: 'File,',
          ariaMode: 'presentational',
        })}
        {fileName}
      </div>
      <div className={kuiperClassNames('size-and-download')}>
        <div onClick={onView}>{humanize.filesize(fileSize)}</div>
        <Tooltip
          position="top"
          trigger={downloadButton(onDownload)}
          content="Download"
        />
      </div>
    </div>
  </div>
)

Attachment.propTypes = {
  description: string,
  fileName: string,
  fileSize: oneOfType([number, string]),
  onDownload: func,
  onView: func,
  title: string,
}

export default Attachment
